import { Permission, useAbility } from "../logic/rbac";
import { Outlet, useOutletContext } from "react-router-dom";
import AccessDenied from "./AccessDenied";

interface PermissionGuardedRouteProps {
  permission: Permission;
}

export const PermissionGuardedRoute = ({ permission }: PermissionGuardedRouteProps) => {
  
    const { can } = useAbility();
    const context = useOutletContext();
    
    return can(permission) ? (
        <Outlet context={context}/>
    ) : (
        <AccessDenied />
    );
};